import {TemplateResult, html, css} from 'lit';
import {customElement, state} from 'lit/decorators.js';
import {msg, localized} from '@lit/localize';
import BaseElement from 'gmfapi/elements/BaseElement';
import {BehaviorSubject, Subscription, combineLatest} from 'rxjs';

import {IOrder} from '../../services/geoshop_api';
import geoshopOrder from '../../services/geoshop_order';

@localized()
@customElement('geoshop-order')
export class GeoShoppingCart extends BaseElement {
  @state() currentOrder: IOrder | null = null;
  private subscriptions: Subscription[] = [];

  connectedCallback(): void {
    super.connectedCallback();
    this.subscriptions.push(geoshopOrder.currentOrder.subscribe((order) => (this.currentOrder = order)));
  }

  disconnectedCallback(): void {
    super.disconnectedCallback();
    this.subscriptions.forEach((subscription) => subscription.unsubscribe());
  }

  render(): TemplateResult {
    return html`
      <div
        id="geoshop-order"
        class="geoshop-block"
        style="${this.currentOrder === null ? 'display:none' : ''}"
      >
        Current Order: ${this.currentOrder?.url?.replace(/.*\/([0-9]+)\//, '$1')} ${this.currentOrder?.title}
        <br />
        Status: ${this.currentOrder?.order_status === 'PROCESSED' ? 'Ready for download' : 'Processing order'}
        <br />
        <button
          href="#"
          class="plain-button"
          ?disabled=${this.currentOrder?.order_status !== 'PROCESSED'}
          @click="${() => geoshopOrder.downloadOrder(this.currentOrder)}"
        >
          <span>
            <span>Download</span>
            <span class="placeholder"> </span>
            <span id="spinner">
              <img class="fa-spin" />
            </span>
            <span id="order-download"> </span>
          </span>
        </button>
      </div>
    `;
  }
}
